module.exports = __webpack_public_path__ + "static/media/EasterDonate2.7d190958.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/EasterDonate2.png
// module id = 50
// module chunks = 0